export default __webpack_public_path__ + "16fcd7a.png";